"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const JkcColorPicker_1 = __importDefault(require("./JkcColorPicker"));
const JkcColor = (props) => {
    const { name, settings, onChangeEvent } = props;
    const moreColors = [
        "#b71c1c",
        "#880e4f",
        "#4a148c",
        "#311b92",
        "#1a237e",
        "#0d47a1",
        "#01579b",
        "#006064",
        "#004d40",
        "#194D33",
        "#33691e",
        "#827717",
        "#f57f17",
        "#ff6f00",
        "#e65100",
        "#bf360c",
        "#3e2723",
        "#263238",
        "#000000",
        "#d32f2f",
        "#c2185b",
        "#7b1fa2",
        "#512da8",
        "#303f9f",
        "#1976d2",
        "#0288d1",
        "#0097a7",
        "#00796b",
        "#388e3c",
        "#689f38",
        "#afb42b",
        "#fbc02d",
        "#ffa000",
        "#f57c00",
        "#e64a19",
        "#5d4037",
        "#455a64",
        "#525252",
        "#f44336",
        "#e91e63",
        "#9c27b0",
        "#673ab7",
        "#3f51b5",
        "#2196f3",
        "#03a9f4",
        "#00bcd4",
        "#009688",
        "#4caf50",
        "#8bc34a",
        "#cddc39",
        "#ffeb3b",
        "#ffc107",
        "#ff9800",
        "#ff5722",
        "#795548",
        "#607d8b",
        "#969696",
        "#e57373",
        "#f06292",
        "#ba68c8",
        "#9575cd",
        "#7986cb",
        "#64b5f6",
        "#4fc3f7",
        "#4dd0e1",
        "#4db6ac",
        "#81c784",
        "#aed581",
        "#dce775",
        "#fff176",
        "#ffd54f",
        "#ffb74d",
        "#ff8a65",
        "#a1887f",
        "#90a4ae",
        "#D9D9D9",
        "#ffcdd2",
        "#f8bbd0",
        "#e1bee7",
        "#d1c4e9",
        "#c5cae9",
        "#bbdefb",
        "#b3e5fc",
        "#b2ebf2",
        "#b2dfdb",
        "#c8e6c9",
        "#dcedc8",
        "#f0f4c3",
        "#fff9c4",
        "#ffecb3",
        "#ffe0b2",
        "#ffccbc",
        "#d7ccc8",
        "#cfd8dc",
        "#FFFFFF",
    ];
    const [showPicker, setShowPicker] = (0, react_1.useState)(false);
    let labelStyle = {
        marginBottom: "0px",
        position: settings.isNormalLabel ? "relative" : "absolute",
        paddingLeft: settings.isNormalLabel ? "0px" : "6px",
        fontSize: "16px",
        fontWeight: "bold",
    };
    let inputStyle = {
        width: "100%",
        padding: settings.isNormalLabel ? "0px 5px 0px 5px" : "10px 5px 0px 5px",
        fontSize: "15px",
        border: "1px solid #D3D3D3",
        outline: "none",
        background: "transparent",
    };
    let fieldStyle = {
        position: "relative",
        width: '100%',
        display: (settings.fieldTypes == 'Grid') ? 'flex' : 'block',
        borderTop: (settings.fieldTypes == 'Grid') ? '1px solid #dddddd' : 'none',
        borderBottom: (settings.fieldTypes == 'Grid') ? '1px solid #dddddd' : 'none',
        marginTop: "-1px"
    };
    if (settings.fieldTypes == 'Grid') {
        fieldStyle.alignItems = 'center';
    }
    let fieldLablStyle = {
        width: (settings.fieldTypes == 'Grid') ? '30%' : '100%',
        padding: (settings.fieldTypes == 'Grid') ? '10px 10px' : '0px'
    };
    let fieldInputStyle = {
        width: (settings.fieldTypes == 'Grid') ? '70%' : '100%',
        padding: (settings.fieldTypes == 'Grid') ? '10px 10px' : '0px',
        borderLeft: (settings.fieldTypes == 'Grid') ? '1px solid #dddddd' : 'none',
        position: 'relative'
    };
    if (settings.fieldTypes == 'Grid') {
        fieldLablStyle.textAlign = 'right';
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: fieldStyle, className: "component-area-cn" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldLablStyle }, { children: !settings.hideLabel ? ((0, jsx_runtime_1.jsx)("label", Object.assign({ style: Object.assign(Object.assign({}, labelStyle), settings.labelStyle), htmlFor: name }, { children: settings.label ? settings.label : "Label" }))) : null })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: fieldInputStyle }, { children: [(0, jsx_runtime_1.jsx)("input", { id: settings.id ? settings.id : name, name: name, tabIndex: settings.tabIndex ? settings.tabIndex : undefined, disabled: settings.disabled ? settings.disabled : false, readOnly: settings.readOnly ? settings.readOnly : false, placeholder: settings.placeholder ? settings.placeholder : "", type: "text", onClick: () => setShowPicker(true), className: settings === null || settings === void 0 ? void 0 : settings.className, style: Object.assign(Object.assign({}, inputStyle), settings.inputStyle), value: settings.value, onChange: onChangeEvent }), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: {
                            position: "absolute",
                            display: "flex",
                            zIndex: 999,
                            right: (settings.fieldTypes == 'Grid') ? "23px" : "14px",
                            height: settings.inputStyle.height,
                            alignItems: "center",
                            justifyContent: "center",
                            bottom: (settings.fieldTypes == 'Grid') ? "10px" : "0px",
                        } }, { children: (0, jsx_runtime_1.jsx)("span", { onClick: () => setShowPicker(true), style: {
                                backgroundColor: settings === null || settings === void 0 ? void 0 : settings.value,
                                width: "16px",
                                height: "16px",
                            } }) }))] })), showPicker ? ((0, jsx_runtime_1.jsxs)(Modal_1.default, Object.assign({ show: showPicker, onHide: () => setShowPicker(false), size: "lg", centered: true }, { children: [(0, jsx_runtime_1.jsx)(Modal_1.default.Header, Object.assign({ closeButton: true }, { children: "Select Color" })), (0, jsx_runtime_1.jsx)(Modal_1.default.Body, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { maxWidth: '100%', maxHeight: 500, overflowX: 'auto' } }, { children: (0, jsx_runtime_1.jsx)(JkcColorPicker_1.default, { closeColorModal: () => setShowPicker(false), settings: settings, onChangeEvent: onChangeEvent, moreColors: moreColors }) })) })] }))) : null] })));
};
exports.default = JkcColor;
